import React from "react";
import TwoFactor from "../../component/settings/twofa";
export function Twofa() {
  return <TwoFactor />;
}
